<template>
  <div class="p-6 bg-gray-900 min-h-screen text-white">
    <!-- عنوان اصلی -->
    <div class="flex justify-between items-center mb-8">
      <h2 class="text-2xl font-bold">داشبورد</h2>
      <a href="/add-item" class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition duration-300">
        افزودن فیلم
      </a>
    </div>

    <!-- آمار و ارقام -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 mb-8">
      <!-- بازدید کل -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex items-center justify-between">
          <span class="text-gray-400">بازدید کل</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6 " fill="#007eff">
            <path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"/>
          </svg>
        </div>
        <p class="text-3xl font-bold mt-2">{{ get_currency(info_data.views) }}</p>
      </div>

      <!-- بازدید این ماه -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex items-center justify-between">
          <span class="text-gray-400">بازدید این ماه</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6 " fill="#007eff">
            <path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"/>
          </svg>
        </div>
        <p class="text-3xl font-bold mt-2">{{ get_currency(info_data.monthly_views) }}</p>
      </div>

      <!-- کل کاربران -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex items-center justify-between">
          <span class="text-gray-400">کل کاربران</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6 text-white" fill="#007eff">
            <path d="M10,13H4a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V14A1,1,0,0,0,10,13ZM9,19H5V15H9ZM20,3H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,9H15V5h4Zm1,7H18V14a1,1,0,0,0-2,0v2H14a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V18h2a1,1,0,0,0,0-2ZM10,3H4A1,1,0,0,0,3,4v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4A1,1,0,0,0,10,3ZM9,9H5V5H9Z"/>
          </svg>
        </div>
        <p class="text-3xl font-bold mt-2">{{ get_currency(info_data.all_users) }}</p>
      </div>

      <!-- کل فروش -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex items-center justify-between">
          <span class="text-gray-400">کل فروش</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6 text-white" fill="#007eff">
            <path d="M10,13H4a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V14A1,1,0,0,0,10,13ZM9,19H5V15H9ZM20,3H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,9H15V5h4Zm1,7H18V14a1,1,0,0,0-2,0v2H14a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V18h2a1,1,0,0,0,0-2ZM10,3H4A1,1,0,0,0,3,4v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4A1,1,0,0,0,10,3ZM9,9H5V5H9Z"/>
          </svg>
        </div>
        <p class="text-3xl font-bold mt-2">{{ get_currency(info_data.payments) }}</p>
      </div>

      <!-- کامنت‌های جدید -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex items-center justify-between">
          <span class="text-gray-400">کامنت‌های جدید</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6 text-white" fill="#007eff">
            <path d="M8,11a1,1,0,1,0,1,1A1,1,0,0,0,8,11Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,12,11Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,16,11ZM12,2A10,10,0,0,0,2,12a9.89,9.89,0,0,0,2.26,6.33l-2,2a1,1,0,0,0-.21,1.09A1,1,0,0,0,3,22h9A10,10,0,0,0,12,2Zm0,18H5.41l.93-.93a1,1,0,0,0,.3-.71,1,1,0,0,0-.3-.7A8,8,0,1,1,12,20Z"/>
          </svg>
        </div>
        <p class="text-3xl font-bold mt-2">{{ get_currency(info_data.comments) }}</p>
      </div>

      <!-- گزارش و شکایات -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex items-center justify-between">
          <span class="text-gray-400">گزارش و شکایات</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6 text-white" fill="#007eff">
            <path d="M22,9.67A1,1,0,0,0,21.14,9l-5.69-.83L12.9,3a1,1,0,0,0-1.8,0L8.55,8.16,2.86,9a1,1,0,0,0-.81.68,1,1,0,0,0,.25,1l4.13,4-1,5.68A1,1,0,0,0,6.9,21.44L12,18.77l5.1,2.67a.93.93,0,0,0,.46.12,1,1,0,0,0,.59-.19,1,1,0,0,0,.4-1l-1-5.68,4.13-4A1,1,0,0,0,22,9.67Zm-6.15,4a1,1,0,0,0-.29.88l.72,4.2-3.76-2a1.06,1.06,0,0,0-.94,0l-3.76,2,.72-4.2a1,1,0,0,0-.29-.88l-3-3,4.21-.61a1,1,0,0,0,.76-.55L12,5.7l1.88,3.82a1,1,0,0,0,.76.55l4.21.61Z"/>
          </svg>
        </div>
        <p class="text-3xl font-bold mt-2">{{ get_currency(info_data.complaints) }}</p>
      </div>
    </div>

    <!-- جداول و بخش‌های دیگر -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- برترین فیلم‌ها -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-bold">برترین فیلم‌ها</h3>
          <a href="/items-list" class="bg-blue-600 text-white text-sm rounded p-1">نمایش همه</a>
        </div>
        <table class="w-full">
          <thead>
          <tr class="border-b border-gray-700">
            <th class="text-right py-2">ردیف</th>
            <th class="text-right py-2">نام</th>
            <th class="text-right py-2">نوع</th>
            <th class="text-right py-2">تعداد بازدید</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in info_data.top_posters" :key="index" class="border-b border-gray-700 hover:bg-gray-750 transition duration-300">
            <td class="py-2">{{ index + 1 }}</td>
            <td class="py-2">{{ item.name }}</td>
            <td class="py-2">{{ item.type == 1 ? 'فیلم' : 'سریال' }}</td>
            <td class="py-2">{{ get_currency(item.views) }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- آخرین فیلم‌ها -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex justify-between items-center mb-4 ">
          <h3 class="text-xl font-bold">آخرین فیلم‌ها</h3>
          <a href="/items-list" class="bg-blue-600 text-white text-sm rounded p-1">نمایش همه </a>
        </div>
        <table class="w-full">
          <thead>
          <tr class="border-b border-gray-700">
            <th class="text-right py-2">ردیف</th>
            <th class="text-right py-2">نام</th>
            <th class="text-right py-2">نوع</th>
            <th class="text-right py-2">تعداد بازدید</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in info_data.last_posters" :key="index" class="border-b border-gray-700 hover:bg-gray-750 transition duration-300">
            <td class="py-2">{{ index + 1 }}</td>
            <td class="py-2">{{ item.name }}</td>
            <td class="py-2">{{ item.type == 1 ? 'فیلم' : 'سریال' }}</td>
            <td class="py-2">{{ get_currency(item.views) }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- آخرین کاربران -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-bold">آخرین کاربران</h3>
          <a href="/users" class="bg-blue-600 text-white text-sm rounded p-1">نمایش همه</a>
        </div>
        <table class="w-full">
          <thead>
          <tr class="border-b border-gray-700">
            <th class="text-right py-2">ردیف</th>
            <th class="text-right py-2">نام</th>
            <th class="text-right py-2">موبایل</th>
            <th class="text-right py-2">تاریخ</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in info_data.last_users" :key="index" class="border-b border-gray-700 hover:bg-gray-750 transition duration-300">
            <td class="py-2">{{ index + 1 }}</td>
            <td class="py-2">{{ item.name }}</td>
            <td class="py-2">{{ item.phone }}</td>
            <td class="py-2">{{ get_date(item.created_at) }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- آخرین کامنت‌ها -->
      <div class="bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-bold">آخرین کامنت‌ها</h3>
          <a href="/comments" class="bg-blue-600 text-white text-sm rounded p-1">نمایش همه</a>
        </div>
        <table class="w-full">
          <thead>
          <tr class="border-b border-gray-700">
            <th class="text-right py-2">ردیف</th>
            <th class="text-right py-2 pr-4">توضیح</th>
            <th class="text-right py-2">تاریخ</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in info_data.last_comments" :key="index" class="border-b border-gray-700 hover:bg-gray-750 transition duration-300">
            <td class="py-2">{{ index + 1 }}</td>
            <td class="py-2">{{ item.message }}</td>
            <td class="py-2">{{ get_date(item.created_at) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'Home',
  data() {
    return {
      info_data: {},
    };
  },
  mounted() {
    this.get_data();
  },
  methods: {
    get_currency(price) {
      if (price == null) return 0;
      price = price.toString().replace(/,/g, '');
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    get_data() {
      const self = this;
      axios.post('dashboard_data', {})
          .then(response => {
            self.info_data = response.data;
          })
          .catch(error => {
            console.log(error);
          });
    },
    get_date(date) {
      // تابع تبدیل تاریخ به فرمت مورد نظر
      return new Date(date).toLocaleDateString('fa-IR');
    },
  },
};
</script>

<style scoped>
/* استایل‌های سفارشی */
</style>